import { Component } from '@angular/core';
import {MenuModule} from "@progress/kendo-angular-menu";
import {TranslationService} from "../../../services/translation/translation.service";
import {DropDownsModule} from "@progress/kendo-angular-dropdowns";
import {FormsModule} from "@angular/forms";
import { TranslatePipe } from '@ngx-translate/core';
import { IntlService } from '@progress/kendo-angular-intl';

@Component({
  selector: 'af-translator',
  imports: [
    MenuModule,
    DropDownsModule,
    FormsModule,
    TranslatePipe
  ],
  templateUrl: './translator.component.html',
  styleUrl: './translator.component.scss'
})

export class TranslatorComponent {

  public languages: Array<{ text: string; value: string }> = [
    { text: 'English', value: 'en' },
    { text: 'German', value: "de" }
  ];

  public language = { text: '', value: this.translationService.getLanguage() };

  constructor(
    private translationService: TranslationService,
    public intlService: IntlService
  ) {}

  switchLanguage(event: any) {
    const lang = event.value;
    this.translationService.setLanguage(lang!);
  }

}
